"use strict";
const React = require('react');
const TextField_1 = require('material-ui/TextField');
const lodash_1 = require('lodash');
const format = require('../utils/format');
const MAX_INPUT_LENGTH = 4;
class DurationInput extends React.Component {
    constructor(props) {
        super(props);
        this.buildStateFromProps = (props) => ({
            hhmm: this.getHhmmFromProps(props),
            errorText: '',
        });
        this.handleKeyDown = (e) => {
            e.preventDefault();
            let parsedInt;
            // e.key is 'Unidentified' in Safari.
            if (e.key === 'Unidentified') {
                // Ignore non-numeric keypresses.
                if (e.keyCode < 48 || e.keyCode > 57) {
                    return;
                }
                parsedInt = e.keyCode - 48;
            }
            else {
                parsedInt = parseInt(e.key, 10);
            }
            let hhmm;
            switch (true) {
                // Numerics (0-9).
                case !isNaN(parsedInt):
                    hhmm = this.state.hhmm + parsedInt;
                    if (hhmm.length > MAX_INPUT_LENGTH) {
                        hhmm = hhmm.substr(1);
                    }
                    break;
                // Backspace.
                case e.key === 'Backspace':
                    hhmm = '0' + this.state.hhmm.substr(0, this.state.hhmm.length - 1);
                    break;
                default:
                    hhmm = this.state.hhmm;
            }
            let errorText = '';
            if (parseInt(hhmm, 10) > 2400) {
                errorText = 'Hey, one day at a time!';
            }
            this.setState({ hhmm, errorText });
        };
        this.state = {
            hhmm: this.getHhmmFromProps(props),
            errorText: '',
        };
    }
    componentWillReceiveProps(nextProps) {
        this.setState(this.buildStateFromProps(nextProps));
    }
    getHhmmFromProps(props) {
        const duration = props.defaultDuration;
        let hhmm = format.timeHiddenInput(duration);
        hhmm = lodash_1.padStart(hhmm, MAX_INPUT_LENGTH, '0');
        return hhmm;
    }
    getMilliseconds() {
        const input = this.state.hhmm;
        const hours = parseInt(input.substr(0, 2), 10);
        const minutes = parseInt(input.substr(2), 10);
        return 1000 * ((hours * 60 * 60) + (minutes * 60));
    }
    formatHhmm() {
        if (this.state.hhmm === '0000') {
            return '';
        }
        const hh = this.state.hhmm.substr(0, 2);
        const mm = this.state.hhmm.substr(2);
        return `${hh} : ${mm}`;
    }
    render() {
        return (React.createElement(TextField_1.default, {ref: "input", type: "tel", errorText: this.state.errorText, disabled: this.props.disabled, hintText: this.props.hint, fullWidth: true, value: this.formatHhmm(), onKeyDown: this.handleKeyDown}));
    }
}
DurationInput.defaultProps = {
    hint: 'hh : mm',
    disabled: false,
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DurationInput;



/** WEBPACK FOOTER **
 ** ./src/components/DurationInput.tsx
 **/